exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changebanners[data-v-7de73ea1]{padding-right:20px;padding-top:20px}.avatar-uploader .el-upload[data-v-7de73ea1]{border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-7de73ea1]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-7de73ea1]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center;border:1px dashed #d9d9d9}.avatar[data-v-7de73ea1]{width:178px;height:178px;display:block}\n", ""]);

// exports
